import React from 'react';

import HeartIcon from '@discover-ui/icons/heart-filled.svg';
import Stars from '@discover-components/restaurant/rating/stars';

const HowItWorksRestaurantLove = () => (
  <>
    <h3 className="mb-3 font-serif text-lg text-brand-blue sm:text-xl">
      Why Restaurants{' '}
      <HeartIcon aria-hidden="true" className="size-7 -translate-y-0.5 text-red-500 sm:size-9" />{' '}
      First Table
    </h3>
    <p className="text-sm sm:text-base">
      Restaurants love First Table because it fills their empty tables and brings in new customers.
      You will get the <span className="font-bold">same great food and service</span> - no cut
      corners, just a win-win for everyone.
    </p>
    <blockquote className="mt-6 border-l border-border pb-2 pl-4">
      <Stars count={5} size={20} className="mb-2" />
      <i className="text-base leading-normal sm:text-[18px]">
        &quot;The service was exceptional, and the food was top-notch even with the discount.&quot;
      </i>
    </blockquote>
  </>
);

export default HowItWorksRestaurantLove;
